import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['selectedAction', 'actionButton']
    static values = { loginGuidePdfLink: String }

    connect() {
        this.actionLink = ''
        const userIds = this.readUserIds()
        userIds.forEach((id) => {
            const el = document.getElementById(`user_id_${id}`)
            if (el) el.checked = true
        })
    }

    disconnect() {
        this.submitForm()
    }

    changeOption(event) {
        event.preventDefault()
        this.enableSubmit()
        switch (this.selectedActionTarget.value) {
            case 'ログイン案内PDF出力':
                this.actionLink = this.loginGuidePdfLinkValue
                this.setActionButtonHref()
                return
            default:
                this.actionLink = ''
                this.setActionButtonHref()
                return
        }
    }

    setActionButtonHref() {
        if (!this.actionLink) {
            return this.actionButtonTarget.href = ''
        }
        const userIds = this.readUserIds()
        const actionUserIds = userIds.length > 0 ? userIds : document.getElementById("search_user_ids").value.split(' ')
        const url = new URL(this.actionLink)
        const params = url.searchParams
        params.append("user_ids", actionUserIds)
        this.actionButtonTarget.href = url.href
    }

    checkAction(event) {
        if (!this.actionLink) {
            this.cancelEvent(event)
            return
        } else {
            this.disabledSubmit()
            this.submitForm()
        }
    }

    cancelEvent(event) {
        event.preventDefault()
        event.stopPropagation()
    }

    toggleParamUserId(event) {
        this.checkboxItem(event)
        this.setActionButtonHref()
    }

    readUserIds() {
        const userIds = localStorage.getItem('coporationUser_userIds')
        return userIds ? userIds.split(",") : []
    }

    setUserIds(ids) {
        const userIds = ids.join(",")
        localStorage.setItem('coporationUser_userIds', userIds)
    }

    addIdToUserIds(id) {
        const lastUserIds = this.readUserIds()
        const foundIndex = lastUserIds.indexOf(id)
        if (foundIndex < 0) {
            lastUserIds.push(id)
            this.setUserIds(lastUserIds)
        }
    }

    removeIdFromUserIds(id) {
        const lastUserIds = this.readUserIds()
        const foundIndex = lastUserIds.indexOf(id)
        if (foundIndex > -1) {
            lastUserIds.splice(foundIndex, 1)
            this.setUserIds(lastUserIds)
        }
    }

    checkboxItem(event) {
        this.enableSubmit()
        const { value, checked } = event.target
        checked ? this.addIdToUserIds(value) : this.removeIdFromUserIds(value)
    }

    submitForm() {
        localStorage.removeItem('coporationUser_userIds')
        document.querySelectorAll('[name="user_id"]').forEach((node) => {
            node.checked = false
        })
    }

    enableSubmit() {
        this.actionButtonTarget.disabled = false
    }

    disabledSubmit() {
        this.actionButtonTarget.disabled = true
    }
}
